var GMEAN_EARTH_RADIUS_METERS = 6367450;
var GMEAN_EARTH_RADIUS_KM = 6367.45;
var GMEAN_EARTH_RADIUS_MILES = 3956.55;
var GMEAN_EARTH_RADIUS_NM = 3438.15;

// Haversine formula
function distanceHaversine(lat1, lon1, lat2, lon2, R) {
    var dLat = (lat2-lat1) * Math.PI/180;
    var dLon = (lon2-lon1) * Math.PI/180;
    var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI/180) * Math.cos(lat2 * Math.PI/180) *
    Math.sin(dLon/2) * Math.sin(dLon/2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    var d = R * c;
    return d;
}

function distanceHaversineKM(lat1, lon1, lat2, lon2) {
    return distanceHaversine(lat1, lon1, lat2, lon2, GMEAN_EARTH_RADIUS_KM);
}

// Spherical law of cosines
function distanceSloc(lat1, lon1, lat2, lon2, R) {
    var rlat1 = lat1 * Math.PI/180;
    var rlon1 = lon1 * Math.PI/180;
    var rlat2 = lat2 * Math.PI/180;
    var rlon2 = lon2 * Math.PI/180;
    var d = Math.acos(Math.sin(rlat1)*Math.sin(rlat2) +
        Math.cos(rlat1)*Math.cos(rlat2) *
        Math.cos(rlon2-rlon1)) * R;
    return d;
}

function distanceSlocKM(lat1, lon1, lat2, lon2) {
    return distanceSloc(lat1, lon1, lat2, lon2, GMEAN_EARTH_RADIUS_KM)
}